<script lang="ts">
const __DsBlock = {
	events: [
		{
			name: 'clear',
			payload: [],
		},
		{
			name: 'update:open',
			payload: [
				{
					name: 'value',
					type: 'boolean',
					required: true,
					array: false,
				},
			],
		},
	],
}
</script>
<script setup lang="ts">
defineEmits<{
	'clear': [];
	'update:open': [value: boolean];
}>();

;
</script>

<template>
	<div />
</template>
